import { uploadSingleFile } from "../files";
import { API, authClient } from "../index";

// Get all faqs
export const getAllCategoryFaqs = () => {
    return authClient().get(`${API}/categoryFaqs/?getDisabled=true`);
};

// Get categoryFaqs by id
export const getCategoryFaqById = (id) => {
    return authClient().get(`${API}/categoryFaqs/${id}`);
};

// Delete categoryFaqs
export const deleteCategoryFaq = (id) => {
    return authClient().delete(`${API}/categoryFaqs/${id}`);
};

export const swapOrdersCategoryFaq = async (id1, id2) => {
    return authClient().post(`${API}/categoryFaqs/swap-orders`, { id1, id2 });
};

// Create categoryFaqs
export const postCategoryFaq = async (categoryFaqs) => {
    const name = categoryFaqs?.title?.en?.toLowerCase().replace(/ /g, "-");
    for (const faq of categoryFaqs.faqs) {
        if (!faq.file)
            continue

        const response = await uploadSingleFile(faq.file, `categoryFaqs/${name}`);
        faq.fileURL = response?.data?.fileURL;
    }
    return authClient().post(`${API}/categoryFaqs`, categoryFaqs);
};

// Update categoryFaqs
export const updateCategoryFaq = async (id, categoryFaqs) => {
    const name = categoryFaqs?.title?.en?.toLowerCase().replace(/ /g, "");
    for (const faq of categoryFaqs.faqs) {
        if (!faq.file)
            continue

        const response = await uploadSingleFile(faq.file, `categoryFaqs/${name}`);
        faq.fileURL = response?.data?.fileURL;
    }
    return authClient().put(`${API}/categoryFaqs/${id}`, categoryFaqs);
};

// Change status category faq
export const changeStatusCategoryFaq = async (id, active) => {
    return authClient().put(`${API}/categoryFaqs/change-status/${id}`, { active });
};